/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjcCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import * as wjrGridFilter from "@grapecity/wijmo.react.grid.filter"

import React, { useEffect, useState } from "react"
import { Button, Col, Container, Row } from "react-bootstrap"
import CONSTANT from "../../constant"

import SyainService from "../../service/master/syain/syainService"
import { 社員マスタ } from "../../service/master/syain/TSyain"

import {
  TWijmoCellTemplateContext,
  TWijmoComboBox,
} from "../../type/wijmoComponents"
import ComboBox from "../../components/ComboBox"
import { T部所マスタ } from "../ComboBox/BusyoComboBox"
import { T区分マスタ } from "../ComboBox/KubunComboBox"
import EmptyTextHeader from "../FlexGridWrapper/EmptyTextHeader"
import GridFooter from "../FlexGridWrapper/GridFooter"
import TextInput from "../InputWrapper/TextInput"
import LocalAlertComponent from "../LocalAlertComponent"
import { ModalOuter, TModalTypes } from "../Modal/ModalOuter"
import Spinner from "../Spinner"
import BusyoService from "../../service/master/busyo/busyoService"
import KubunService from "../../service/master/kubun/kubunService"
import { 区分分類コード } from "../../constant/enum/codes"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSearch } from "@fortawesome/free-solid-svg-icons"

//#region [type]

// DefaultCombo
export type TItem = { name: string; value: any }
const boolList: TItem[] = [
  {
    name: "在籍",
    value: "0",
  },
  {
    name: "退職",
    value: "1",
  },
]

// #endregion

/**
 * 社員検索モーダル
 * @param {*} props
 * @return {*} reactNode
 */
const SyainSearchModal: React.FC<
  Omit<TModalTypes, "title"> & {
    title?: string
    footer?: React.ReactNode
    setSyain: (value: 社員マスタ) => unknown
  }
> = (props) => {
  //#region [state]
  // 検索項目
  const [社員氏名, set社員氏名] = useState<string>()
  const [社員コード, set社員コード] = useState<string>()

  // combobox
  // 部所
  const [部所コード, set部所コード] = useState<string | null>()
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()
  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<
    T部所マスタ["部所コード"],
    T部所マスタ
  > | null>(null)
  const [部所IsLoadEnded, set部所IsLoadEnded] = useState<boolean>(false)
  // 社員区分
  const [社員区分コード, set社員区分コード] = useState<string | null>()
  const [社員区分ItemSource, set社員区分ItemSource] = useState<T区分マスタ[]>()
  const [社員区分ComboBox, set社員区分ComboBox] = useState<TWijmoComboBox<
    T区分マスタ["区分コード"],
    T区分マスタ
  > | null>(null)
  const [社員区分IsLoadEnded, set社員区分IsLoadEnded] = useState<boolean>(false)
  // 退職フラグ
  const [退職フラグComboBox, set退職フラグComboBox] = useState<TWijmoComboBox<
    number,
    TItem
  > | null>(null)
  const [退職フラグIsLoadEnded, set退職フラグIsLoadEnded] =
    useState<boolean>(false)
  const [退職フラグItemSource, set退職フラグItemSource] = useState<TItem[]>()
  const [退職フラグ, set退職フラグ] = useState<string | null>(null)

  // Grid
  const [pageSize, setPageSize] = useState<number>(50)

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()

  // Spinner用
  const [isSpinnerShow, setIsSpinnerShow] = useState(false)

  // アラート用State
  const [AlertSource, setAlertSource] = useState<any>()
  //#endregion

  //#region [method]
  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページサイズ
   * @returns CollectionView
   */

  const createCollectionView = (data: Array<any>, pageSize: number) =>
    new wjcCore.CollectionView(data, {
      pageSize,
    })

  const [gridData, setGridData] = useState<{
    data: wjcCore.CollectionView
  }>({
    data: createCollectionView([], pageSize),
  })
  const gridInitialized = (grid: wjcGrid.FlexGrid) => {
    grid.itemsSource = gridData.data
    setFlexGrid(grid)
  }

  const search = async () => {
    setIsSpinnerShow(true)
    setAlertSource(undefined)
    try {
      const res = await new SyainService().getList({
        部所コード: 部所コード ? 部所コード : "",
        社員区分コード: 社員区分コード ? 社員区分コード : "",
        社員コード,
        社員氏名,
        退職フラグ:
          退職フラグ != null && !wjcCore.isNullOrWhiteSpace(退職フラグ)
            ? parseInt(退職フラグ)
            : undefined,
      })

      const newData = createCollectionView([...res.data], pageSize)
      flexGrid!.itemsSource = newData
      setGridData({ data: newData })
      flexGrid!.refresh()
    } catch (error) {
      setAlertSource(error)
    } finally {
      setIsSpinnerShow(false)
    }
  }
  /**
   * 選択ハンドラ
   * @param item
   */
  const submitHandler = (item: 社員マスタ) => {
    props.setSyain(item)
    props.setIsShow(false)
  }
  //#endregion

  //#region [effect]
  useEffect(() => {
    if (
      flexGrid == null ||
      部所ComboBox == null ||
      社員区分ComboBox == null ||
      退職フラグComboBox == null
    )
      return

    if (props.isShow) {
      // TODO:APIから取得
      // TODO: APIから取得に修正必須
      Promise.all([
        new BusyoService().getList({}),
        new KubunService().getList(),
      ]).then(([部所ListRes, 区分マスタRes]) => {
        set部所ItemSource(部所ListRes.data)
        set社員区分ItemSource(区分マスタRes.data)
        set退職フラグItemSource(boolList)
      })
    } else {
      // 非表示時中身を空にして閉じる
      set社員氏名("")
      set社員コード("")
      set部所コード("")
      set社員区分コード("")
      set退職フラグ("0")
      const newData = {
        data: createCollectionView([], pageSize),
      }
      if (flexGrid != null) {
        flexGrid.itemsSource = newData.data
        flexGrid.refresh()
      }
      setGridData(newData)
    }
  }, [
    props.isShow,
    flexGrid,
    部所ComboBox,
    社員区分ComboBox,
    退職フラグComboBox,
  ])

  //#endregion
  return (
    <ModalOuter
      isShow={props.isShow}
      title={props.title ?? "社員マスタ検索"}
      setIsShow={props.setIsShow}
      size={"xl"}
      footer={props.footer}>
      <Spinner inModal searching={isSpinnerShow}></Spinner>
      <Container fluid>
        {/* アラート表示 */}
        <Row>
          <Col>
            <LocalAlertComponent alertSource={AlertSource} />
          </Col>
        </Row>
        <form>
          <Row>
            <Col>
              <div className="search-condition-table">
                <div className="search-condition-row">
                  <ComboBox.Busyo
                    autoFocus={true}
                    placeholder="部所"
                    isAllSelect={true}
                    itemsSource={部所ItemSource}
                    isLoadEnded={部所IsLoadEnded}
                    setIsLoadEnded={set部所IsLoadEnded}
                    selectedValue={部所コード}
                    setSelectedValue={set部所コード}
                    ComboBox={部所ComboBox}
                    setComboBox={set部所ComboBox}></ComboBox.Busyo>
                  <ComboBox.Kubun
                    placeholder="社員区分"
                    分類コード={区分分類コード.社員_乗務員.社員区分}
                    isAllSelect={true}
                    itemsSource={社員区分ItemSource}
                    selectedValue={社員区分コード}
                    setSelectedValue={set社員区分コード}
                    isLoadEnded={社員区分IsLoadEnded}
                    setIsLoadEnded={set社員区分IsLoadEnded}
                    ComboBox={社員区分ComboBox}
                    setComboBox={set社員区分ComboBox}></ComboBox.Kubun>
                  <div className="input-group">
                    <TextInput
                      id="社員番号"
                      name="社員番号"
                      value={社員コード}
                      setValue={set社員コード}
                      maxLength={4}
                      placeholder="社員CD"
                      style={{ width: "6rem" }}
                    />
                    <TextInput
                      id="氏名"
                      name="氏名"
                      value={社員氏名}
                      setValue={set社員氏名}
                      maxLength={100}
                      placeholder="氏名"
                    />
                  </div>
                  <ComboBox.Default
                    className="max-w-10rem"
                    placeholder="退職"
                    itemsSource={退職フラグItemSource}
                    selectedValue={退職フラグ}
                    setSelectedValue={set退職フラグ}
                    isLoadEnded={退職フラグIsLoadEnded}
                    setIsLoadEnded={set退職フラグIsLoadEnded}
                    ComboBox={退職フラグComboBox}
                    setComboBox={set退職フラグComboBox}></ComboBox.Default>
                </div>
                <div className="search-condition-row">
                  <Button
                    type="submit"
                    onClick={(e) => {
                      e.preventDefault()
                      search()
                    }}>
                    <FontAwesomeIcon icon={faSearch} />
                    検索
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </form>
        <Row>
          <Col style={{ height: "35rem" }}>
            <wjrGrid.FlexGrid
              {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
              keyActionTab={wjcGrid.KeyAction.None}
              selectionMode={wjcGrid.SelectionMode.Cell}
              initialized={gridInitialized}
              style={{ height: "20rem" }}>
              <wjrGridFilter.FlexGridFilter />
              <wjrGrid.FlexGridColumn
                header="選択"
                align={"center"}
                binding="社員ID">
                <EmptyTextHeader></EmptyTextHeader>
                <wjrGrid.FlexGridCellTemplate
                  cellType={wjrGrid.CellTemplateType.Cell}
                  template={(
                    context: TWijmoCellTemplateContext<社員マスタ>
                  ) => (
                    <Button onClick={() => submitHandler(context.item)}>
                      選択
                    </Button>
                  )}
                />
              </wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={110}
                header="社員CD"
                binding="社員コード"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={110}
                header="社員区分CD"
                binding="社員区分コード"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={250}
                header="社員氏名"
                binding="社員氏名"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={150}
                header="社員氏名カナ"
                binding="社員氏名カナ"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={110}
                header="部所CD"
                binding="部所コード"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                header="部所名"
                binding="部所名"></wjrGrid.FlexGridColumn>
            </wjrGrid.FlexGrid>
            <GridFooter
              pageSize={pageSize}
              setPageSize={setPageSize}
              gridData={gridData}
              isEnableExport={false}
              flexGrid={flexGrid}></GridFooter>
          </Col>
        </Row>
      </Container>
    </ModalOuter>
  )
}
export default SyainSearchModal
